// extracted by mini-css-extract-plugin
module.exports = {"full-width-image":"FullWidthImage-module__full-width-image___2YNDH"};